import createStore from "@Stores/base-factories";
import { hookPageList } from "@Stores/base-factories/store-list";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection";

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('pixel')
  .extendHookCollectionsFactory('pixels')
  .extend(hookPageList())
  .factory()

export {
  Provider as PixelProvider,
  useStore as usePixelStore,
}
